module.exports = __webpack_public_path__ + "static/media/calci.d263da8a.PNG";